import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl46ValidationSchema = () => {
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");
  const regExp = /^\d+\.\d{1,2}$|^\d+$/;
  const numberField = yup
    .string()
    .matches(regExp, t("Το πεδίο πρέπει να είναι θετικός αριθμός"));

  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),

    capitalChangeDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό")),

    depositCheck: yup.string().nullable(),
    noDepositCheck: yup.string().nullable(),

    decidedNewCapital: numberField
      .nullable()
      .when(["depositCheck", "noDepositCheck"], {
        is: (depositCheck: string | null, noDepositCheck: string | null) =>
          !depositCheck && !noDepositCheck,
        then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
      }),

    diffCapital: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),

    finalDiffCapital: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),

    diffCapitalNo: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),

    fudocBankMov: yup
      .mixed()
      .nullable()
      .when(["depositCheck", "noDepositCheck"], {
        is: (depositCheck: string | null, noDepositCheck: string | null) =>
          depositCheck || (!depositCheck && !noDepositCheck),
        then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
      }),

    fudocStatute: yup
      .mixed()
      .nullable()
      .when(["depositCheck", "noDepositCheck"], {
        is: (depositCheck: string | null, noDepositCheck: string | null) =>
          depositCheck || noDepositCheck,
        then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
      }),

    capitalForm1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),

    shareCap1Form1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCapVal1Form1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCap3Form1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCapVal3Form1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCap5Form1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCapVal5Form1: numberField.nullable().when("depositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    capitalForm3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCap1Form3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCapVal1Form3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCap3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCapVal3Form3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCap5Form3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
    shareCapVal5Form3: numberField.nullable().when("noDepositCheck", {
      is: "on",
      then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
    }),
  });
};
